import type { FC } from "react"

import AddProductLocationDialog from "./AddProductLocationDialog"
import AddProductSkuDialog from "./AddProductSkuDialog"
import EditProductInfoDialog from "./EditProductInfoDialog"
import EditProductSpecificsDialog from "./EditProductSpecificsDialog"

import type { Product } from "@/graphql/codegen/graphql"
import { useProductActionsStore } from "@/screens/Companies/products/stores/useProductsActions"
import { ProductActionsDialogs } from "@/screens/Companies/products/types/schema"
import { AddAlternateSourceDialog } from "@/screens/Products/components/dialogs/AddAlternateSourceDialog"

interface ProductEditingDialogsProps {
  product: Product
  onSubmit: () => void
}

const ProductEditingDialogs: FC<ProductEditingDialogsProps> = ({ product, onSubmit }) => {
  const { openedDialog, setOpenedDialog } = useProductActionsStore()
  const setProductAtAction = useProductActionsStore((state) => state.setProductAtAction)

  const handleSubmit = () => {
    onSubmit()
    setOpenedDialog(null)
  }

  const handleClose = () => {
    setOpenedDialog(null)
    setProductAtAction(null)
  }

  return (
    <>
      {openedDialog === ProductActionsDialogs.EDIT_PRODUCT_INFORMATION && (
        <EditProductInfoDialog product={product} onClose={handleClose} onSubmit={handleSubmit} />
      )}
      {openedDialog === ProductActionsDialogs.EDIT_PRODUCT_SPECIFICS && (
        <EditProductSpecificsDialog product={product} onClose={handleClose} onSubmit={handleSubmit} />
      )}
      {openedDialog === ProductActionsDialogs.ADD_SKU && (
        <AddProductSkuDialog product={product} onClose={handleClose} onSubmit={handleSubmit} />
      )}
      {openedDialog === ProductActionsDialogs.ADD_LOCATION && (
        <AddProductLocationDialog product={product} onClose={handleClose} onSubmit={handleSubmit} />
      )}
      {openedDialog === ProductActionsDialogs.ADD_ALTERNATE_SOURCE && (
        <AddAlternateSourceDialog product={product} onClose={handleClose} onSubmit={handleSubmit} />
      )}
    </>
  )
}

export default ProductEditingDialogs
